var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("EmployeeDataProvider", {
    attrs: { familyName: _vm.familyName, givenName: _vm.givenName },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ fullName, initials }) {
          return [
            _c(
              "div",
              { staticClass: "flex items-center max-w-full" },
              [
                _c("StatusChip", {
                  staticClass: "mr-2",
                  attrs: { status: _vm.status },
                }),
                _c("EmployeeCardUserName", {
                  attrs: {
                    employeePageRouteParams: _vm.employeePageRouteParams,
                    givenName: _vm.givenName,
                    familyName: _vm.familyName,
                  },
                }),
                _c("EmployeeTag", {
                  attrs: {
                    fullName: fullName,
                    initials: initials,
                    avatar: _vm.avatar,
                    contractorId: _vm.contractorId,
                    appliedTag: _vm.appliedTag,
                    userUpdatedDate: _vm.userUpdatedDate,
                    defaultTagHidden: "",
                  },
                  on: {
                    tagUpdated: function ($event) {
                      return _vm.$emit("tagUpdated")
                    },
                  },
                }),
              ],
              1
            ),
            _vm.tagName
              ? _c(
                  "div",
                  [_c("EmployeeCardTag", { attrs: { tagName: _vm.tagName } })],
                  1
                )
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }